import { Col, Row } from "react-grid-system";
import Folders from "../folders/list/Folders";
import DeviceCards from "../devices/list/DeviceCards";

export default function Home() {
    return (
        <Row>
            <Col>
                <Folders />
                <DeviceCards />
            </Col>
        </Row>
    );
}